import { useProjectActionAllowed } from "@/hooks/use-action-allowed-in-project";
import { useTenantActionAllowed } from "@/hooks/use-action-allowed-in-tenant";
import { useHccSchematisationQuery } from "@/queries/query-hcc-schematisation";

export const useModelSchematisationPermission = (schematisationId: number) => {
  const { data: schematisation, isLoading } = useHccSchematisationQuery(schematisationId);

  const { canManageDataset } = useTenantActionAllowed();
  const { canWriteProject } = useProjectActionAllowed();

  if (isLoading) {
    return {
      isLoading: true,
      canEditModelSchema: false,
    };
  }

  const isFromCatalogue = schematisation?.ranaProjectId === null;

  const canEditModelSchema = isFromCatalogue ? canManageDataset : canWriteProject;

  return {
    isLoading: false,
    canEditModelSchema,
  };
};
